import React, { useState } from "react";

/**
 * Text plus a copy button.
 *
 * The app doesn't send anything — adding someone permits their address to
 * sign up, and telling them is still a human job. This makes that job one
 * tap rather than retyping a join code from memory.
 */
export default function CopyBox({ text, label = "Copy", rows = 4 }) {
  const [done, setDone] = useState(false);

  async function copy() {
    try {
      await navigator.clipboard.writeText(text);
    } catch {
      // Safari refuses the clipboard API outside a secure context, and
      // older browsers never had it. Select the text instead so the
      // person can copy it the normal way.
      const el = document.getElementById("copybox-text");
      if (el) { el.focus(); el.select(); }
      return;
    }
    setDone(true);
    setTimeout(() => setDone(false), 2000);
  }

  return (
    <div className="copybox">
      <textarea id="copybox-text" className="input" readOnly rows={rows} value={text} />
      <button type="button" className={`btn ${done ? "btn-dark" : "btn-primary"}`} onClick={copy}>
        {done ? "Copied" : label}
      </button>
    </div>
  );
}
